import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createHead } from '@unhead/vue'

import { firebaseApp } from './plugins/firebase'
import trackdeskPlugin from './plugins/trackdesk';
import AnalyticsPlugin from './plugins/analytics'

import { ReCaptchaEnterpriseProvider } from 'firebase/app-check'
import { VueFire, VueFireAuth, VueFireAppCheck } from 'vuefire'
import * as Sentry from "@sentry/vue";

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import {all} from '@awesome.me/kit-9e7c45db70/icons'


import { createGettext } from 'vue3-gettext'
import translations from './language/translations.json'

import "flag-icons/css/flag-icons.min.css";

import { StoryblokVue, apiPlugin } from '@storyblok/vue';

import Grid from "./blocks/Grid.vue";
import Page from "./blocks/Page.vue";
import Teaser from "./blocks/Teaser.vue";
import Feature from "./blocks/Feature.vue";
import Hero from "./blocks/Hero.vue";
import ContentSection from "./blocks/ContentSection.vue";
import TransitSection from "./blocks/TransitSection.vue";
import PdfSection from "./blocks/PdfSection.vue";
import NumberSection from "./blocks/NumberSection.vue";
import BlueprintSection from "./blocks/BlueprintSection.vue";
import FutureSection from "./blocks/FutureSection.vue";
import VisionSection from "./blocks/VisionSection.vue";
import PricingSection from "./blocks/PricingSection.vue";
import TeamSection from "./blocks/TeamSection.vue";
import TestimonialSection from "./blocks/TestimonialSection.vue";
import FaqSection from "./blocks/FaqSection.vue";
import PricingSmallSection from "./blocks/PricingSmallSection.vue";
import CtaSection from "./blocks/CtaSection.vue";
import PremiumContentSection from "./blocks/PremiumContentSection.vue";
import PdfPreviewSection from "./blocks/PdfPreviewSection.vue";
import Footer from "./blocks/Footer.vue";


import './style.css'
import { router } from './router'
import App from './App.vue'

library.add(...all)

const pinia = createPinia()
const head = createHead()

const app = createApp(App)

app.component('FontAwesomeIcon', FontAwesomeIcon)
app.component('FontAwesomeLayers', FontAwesomeLayers)
app.component('FontAwesomeLayersText', FontAwesomeLayersText)

app.component("Grid", Grid);
app.component("Page", Page);
app.component("Teaser", Teaser);
app.component("Feature", Feature);
app.component("Hero", Hero);
app.component("ContentSection", ContentSection);
app.component("TransitSection", TransitSection);
app.component("PdfSection", PdfSection);
app.component("NumberSection", NumberSection);
app.component("BlueprintSection", BlueprintSection);
app.component("FutureSection", FutureSection);
app.component("VisionSection", VisionSection);
app.component("PricingSection", PricingSection);
app.component("TeamSection", TeamSection);
app.component("TestimonialSection", TestimonialSection);
app.component("FaqSection", FaqSection);
app.component("PricingSmallSection", PricingSmallSection);
app.component("CtaSection", CtaSection);
app.component("PremiumContentSection", PremiumContentSection);
app.component("PdfPreviewSection", PdfPreviewSection);
app.component("Footer", Footer);

if (import.meta.env.MODE !== 'development') {
Sentry.init({
  app,
  dsn: "https://9937818a6994dfb55ebe1b5fd707d6c1@o4506042722549760.ingest.us.sentry.io/4507129930842113",
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/firestore\.googleapis\.com/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  trackComponents: true
});
}

app.use(trackdeskPlugin);

app.use(AnalyticsPlugin, {
  router
})

app.use(StoryblokVue, {
  accessToken: import.meta.env.VITE_APP_STORYBLOK_TOKEN,
  use: [apiPlugin],
  version: import.meta.env.VITE_APP_STORYBLOK_VERSION,
});

app.use(VueFire, {
    firebaseApp,
    modules: [
      VueFireAuth()
    ],
  })
app.use(pinia)
app.use(router)
app.use(head)


const defaultLang = 'en'


const gettext = createGettext({
  availableLanguages: {
    de: 'Deutsch',
    en: 'English'
  },
  defaultLanguage: defaultLang,
  translations: translations,
  silent: false
})

app.config.globalProperties.$language = {
  current: defaultLang,
  availableLanguages: ['de', 'en', 'tr']
}

app.use(gettext)

app.mount('#app')

console.log('Running in', import.meta.env.MODE)